import type { IRestaurantData } from 'src/types/restaurant';
import type { ButtonBaseProps } from '@mui/material/ButtonBase';

import { useContext, useCallback } from 'react';

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ButtonBase from '@mui/material/ButtonBase';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { CONFIG } from 'src/config-global';
import { DashboardContext } from 'src/context/dashboard/dashboard-context';

import { Iconify } from 'src/components/iconify';
import { usePopover, CustomPopover } from 'src/components/custom-popover';

// ----------------------------------------------------------------------

export type RestaurantsPopoverProps = ButtonBaseProps & {
  data?: IRestaurantData[];
};

export function RestaurantsPopover({ data = [], sx, ...other }: RestaurantsPopoverProps) {
  const popover = usePopover();

  const mediaQuery = 'sm';

  const { selectedRestaurant, setSelectedRestaurant } = useContext(DashboardContext);

  const router = useRouter();

  const handleChangeRestaurant = useCallback(
    (newValue: IRestaurantData) => {
      setSelectedRestaurant(newValue);
      popover.onClose();
    },
    [popover, setSelectedRestaurant]
  );

  return (
    <>
      <ButtonBase
        disableRipple
        onClick={popover.onOpen}
        sx={{
          py: 0.5,
          gap: { xs: 0.5, [mediaQuery]: 1 },
          ...sx,
        }}
        {...other}
      >
        <Avatar
          alt={selectedRestaurant?.name}
          src={`${CONFIG.site.assetURL}${selectedRestaurant?.logo}`}
          sx={{ width: 24, height: 24, fontSize: 12 }}
        />

        <Box
          component="span"
          sx={{
            typography: 'subtitle2',
            display: { xs: 'none', [mediaQuery]: 'inline-flex' },
          }}
        >
          {selectedRestaurant?.name}
        </Box>

        <Iconify width={16} icon="carbon:chevron-sort" sx={{ color: 'text.disabled' }} />
      </ButtonBase>

      <CustomPopover
        open={popover.open}
        anchorEl={popover.anchorEl}
        onClose={popover.onClose}
        slotProps={{ arrow: { placement: 'top-left' } }}
      >
        <MenuList sx={{ width: 240, maxHeight: 400, overflowY: 'scroll' }}>
          {data.map((option) => (
            <MenuItem
              key={option._id}
              selected={option._id === selectedRestaurant?._id}
              onClick={() => handleChangeRestaurant(option)}
              sx={{ height: 48 }}
            >
              <Avatar
                alt={option.name.toUpperCase()}
                src={`${CONFIG.site.assetURL}${option?.logo}`}
                sx={{ width: 24, height: 24, fontSize: 12 }}
              />

              <Box component="span" sx={{ flexGrow: 1 }}>
                {option.name}
              </Box>
            </MenuItem>
          ))}
          <MenuItem
            onClick={() => router.push(paths.dashboard.createRestaurant)}
            sx={{ height: 48 }}
          >
            <Avatar sx={{ width: 24, height: 24, fontSize: 12, bgcolor: 'grey.400' }}>
              <Iconify width={16} icon="ic:round-plus" sx={{ color: 'black' }} />
            </Avatar>

            <Box component="span" sx={{ flexGrow: 1 }}>
              Yeni Restoran Oluştur
            </Box>
          </MenuItem>
        </MenuList>
      </CustomPopover>
    </>
  );
}
